import React from 'react';
import Translate from "../../../../../components/Translate";
import EditButton from "../../../../../components-new/buttons/actions/EditButton";
import DeleteButton from "../../../../../components-new/buttons/actions/DeleteButton";
import ContactAvatar from "../../../../../components-new/general/ContactAvatar";
import {GroupRole} from "../../../../../services/internalGroups/constants";

const Division = ({division, onEditDivisionClick, onDeleteDivisionClick, departmentId}) => {

    const divisionHead = division.members
        ? division.members.find(member => member.groupRole === GroupRole.DIVISION_HEAD)
        : null;
    const members = division.members
        ? division.members.filter(member => member.groupRole !== GroupRole.DIVISION_HEAD)
        : [];

    return (
        <div key={division.id} className="internal-grouping__division">
            <div className="internal-grouping__division-content">
                    <div className="internal-grouping__division-name">{division.name}</div>
                    {division.description && (
                        <div className="internal-grouping__division-description">{division.description}</div>
                    )}
                    <div className="internal-grouping__division-meta">
                        <div className="internal-grouping__head">
                            <span className="internal-grouping__division-meta-label"><Translate text="head"/>:</span>
                            {divisionHead && (
                                <span className="internal-grouping__person">
                                    <ContactAvatar contact={divisionHead} size={24}/>
                                    <span>{divisionHead.firstName} {divisionHead.lastName}</span>
                                </span>
                            )}
                        </div>
                        {members.length > 0 && (
                            <div className="internal-grouping__members">
                                <span className="internal-grouping__division-meta-label"><Translate text="members"/>:</span>
                                <div className="internal-grouping__member-list">
                                    {members.map(member => (
                                        <span className="internal-grouping__member-badge" key={member.id}>
                                            <ContactAvatar contact={member} size={20}/>
                                            <span>{member.firstName} {member.lastName}</span>
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
            </div>
            <div className="internal-grouping__division-actions">
                <EditButton
                    onClick={() => onEditDivisionClick(division, departmentId)}
                    variant={'ghost'}
                />
                <DeleteButton
                    onClick={() => onDeleteDivisionClick(division)}
                    variant={'ghost'}
                />
            </div>
        </div>
    )
}

export default Division



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/internal-grouping/components/Divison.jsx